import { useState } from 'react';
import { personaContent } from '../../content/personaContent';
import messages from '../../i18n/en.json';
import styles from './Initializer.module.css';

function TypeSelectionStep({
  onManualSelect,
  onTextSelect,
  options,
  hideDigitalLegacy = false,
}) {
  const [selectedType, setSelectedType] = useState(null);

  if (!selectedType) {
    return (
      <div>
        <h3>Step 1: Choose a Persona Type</h3>
        <p>Select the type of persona you want to create.</p>
        <div className={styles.typeGrid}>
          {options?.personaTypes?.map((type) => {
            if (hideDigitalLegacy && type === 'digital-me') {
              return null;
            }
            if (type === 'custom') return null;
            const prettyTypeName = messages.persona_types[type] || type;
            const content = personaContent[type] || { title: type };
            return (
              <div
                key={type}
                className={styles.typeCard}
                onClick={() => setSelectedType(type)}
              >
                <h4>
                  {content.icon} {prettyTypeName}
                </h4>
                <p>{content.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  const prettySelectedTypeName =
    messages.persona_types[selectedType] || selectedType;

  return (
    <div>
      <h3>Next: Choose Your Creation Method</h3>
      <p>
        You've selected a "<strong>{prettySelectedTypeName}</strong>" persona.
        How would you like to build it?
      </p>
      <div className={styles.methodGrid}>
        <div
          className={styles.typeCard}
          onClick={() => onManualSelect(selectedType)}
        >
          <h4>🧙‍♂️ Manual Wizard</h4>
          <p>
            A step-by-step process to define every aspect of your persona from
            the ground up.
          </p>
        </div>
        <div
          className={styles.typeCard}
          onClick={() => onTextSelect(selectedType)}
        >
          <div className={styles.cardHeader}>
            <h4>⚡ Create from Text (AI-Powered)</h4>
            <span className={styles.recommendedBadge}>Recommended</span>
          </div>
          <p>
            Provide a name and a block of text, and have our AI generate a
            complete profile for you instantly.
          </p>
        </div>
      </div>
      <div className={styles.buttonGroup}>
        <button
          onClick={() => setSelectedType(null)}
          className="action-button secondary"
        >
          Back to Types
        </button>
      </div>
    </div>
  );
}

export default TypeSelectionStep;
